<template>
  <b-card>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="cog" />ข้อมูลงบประมาณ
    </h6>

    <div class="fund-source">
      <div class="fund-source-title">แหล่งเงินภายใน</div>
      <div class="fund">
        <div class="form-inline">
          <label class="mr-2">เงินสนับสนุนกิจกรรมนักศึกษา</label>
          <b-input
            v-model.number="$v.value.funding.internal.osda.$model"
            :state="$v.value.funding.internal.osda.$dirty ? !$v.value.funding.internal.osda.$error : null"
            type="number" min="0" class="text-center mr-2" :disabled="value.funding.internal.noOsda"
          />
          <span class="mr-4">บาท</span>
          <b-form-checkbox v-model="value.funding.internal.noOsda" :value="true" @change="adjustOsda">
            ไม่ใช้งบสนับสนุนกิจกรรมนักศึกษา
          </b-form-checkbox>
        </div>
      </div>
      <div class="fund">
        <div class="form-inline">
          <label class="mr-2">งบสำรองจ่าย</label>
          <b-input
            v-model.number="$v.value.funding.internal.advance.$model"
            :state="$v.value.funding.internal.advance.$dirty ? !$v.value.funding.internal.advance.$error : null"
            type="number" min="0" class="text-center mr-2"
          />
          <span>บาท</span>
        </div>
      </div>
    </div>

    <div class="fund-source">
      <div class="fund-source-title">แหล่งเงินภายนอก</div>
      <div class="fund">
        <div class="mb-2">งบสนับสนุนจากบริษัท/บุคคล</div>
        <div class="other-funds">
          <div v-for="(_, index) in value.funding.external.sponsors" :key="index" class="form-inline mb-2">
            <label class="mr-2">-</label>
            <b-input v-model.trim="value.funding.external.sponsors[index].name" class="mr-2" />
            <span class="mr-2">จำนวน</span>
            <b-input v-model.number="value.funding.external.sponsors[index].amount" type="number" min="0" class="text-center mr-2" />
            <span class="mr-4">บาท</span>
            <b-button size="sm" variant="outline-danger" @click="deleteSponsorExternalFund(index)">ลบ</b-button>
          </div>

          <div class="form-inline">
            <label class="mr-2">-</label>
            <b-button size="sm" class="mt-2" variant="primary" @click="addSponsorExternalFund">
              <font-awesome-icon icon="plus-circle" />เพิ่มงบสนับสนุนจากบริษัท/บุคคล
            </b-button>
          </div>
        </div>
      </div>
      <div class="fund">
        <div class="mb-2">งบอื่นๆ</div>
        <div class="other-funds">
          <div v-for="(_, index) in value.funding.external.other" :key="index" class="form-inline mb-2">
            <label class="mr-2">-</label>
            <b-input v-model.trim="value.funding.external.other[index].name" class="mr-2" />
            <span class="mr-2">จำนวน</span>
            <b-input v-model.number="value.funding.external.other[index].amount" type="number" min="0" class="text-center mr-2" />
            <span class="mr-4">บาท</span>
            <b-button size="sm" variant="outline-danger" @click="deleteOtherExternalFund(index)">ลบ</b-button>
          </div>

          <div class="form-inline">
            <label class="mr-2">-</label>
            <b-button size="sm" class="mt-2" variant="primary" @click="addOtherExternalFund">
              <font-awesome-icon icon="plus-circle" />เพิ่มงบอื่นๆ
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="fund-source">
      <div class="fund-source-title">รายการของที่รับบริจาคมา</div>
      <div class="fund">
        <div class="other-funds">
          <div v-for="(_, index) in value.funding.donations" :key="index" class="form-inline mb-2">
            <label class="mr-2">-</label>
            <b-input v-model.trim="value.funding.donations[index]" class="mr-2" />
            <b-button size="sm" variant="outline-danger" @click="deleteDonation(index)">ลบ</b-button>
          </div>

          <div class="form-inline">
            <label class="mr-2">-</label>
            <b-button size="sm" class="mt-2" variant="primary" @click="addDonation">
              <font-awesome-icon icon="plus-circle" />เพิ่มของที่ได้รับการบริจาค
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="expense-table-title">รายละเอียดการใช้จ่าย</div>
    <expenses-table v-model="value" />
  </b-card>
</template>

<script>
import ProjectEditValidatorMixins from '@/mixins/projectEditValidatorMixins'
import ExpensesTable from '@/components/project/ExpensesTable'
import { required, minValue, decimal } from 'vuelidate/lib/validators'

export default {
  components: {
    ExpensesTable
  },
  mixins: [ ProjectEditValidatorMixins ],
  props: {
    value: { type: Object, required: true }
  },
  methods: {
    addOtherInternalFund () {
      this.value.funding.internal.other.push({ name: '', amount: 0 })
    },
    deleteOtherInternalFund (index) {
      this.$delete(this.value.funding.internal.other, index)
    },
    addSponsorExternalFund () {
      this.value.funding.external.sponsors.push({ name: '', amount: 0 })
    },
    addOtherExternalFund () {
      this.value.funding.external.other.push({ name: '', amount: 0 })
    },
    deleteSponsorExternalFund (index) {
      this.$delete(this.value.funding.external.sponsors, index)
    },
    deleteOtherExternalFund (index) {
      this.$delete(this.value.funding.external.other, index)
    },
    addDonation () {
      if (this.value.funding.donations === null) {
        this.value.funding.donations = []
      }

      this.value.funding.donations.push('')
    },
    deleteDonation (index) {
      this.$delete(this.value.funding.donations, index)
    },
    adjustOsda (status) {
      if (status === true) {
        this.value.funding.internal.osda = 0
      }
    }
  },
  validations: {
    value: {
      funding: {
        internal: {
          advance: { required, decimal, minValue: minValue(0) },
          osda: { required, decimal, minValue: minValue(0) }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fund-source{
  margin-bottom: 40px;
}

.fund-source-title, .expense-table-title {
  font-weight: $font-weight-bolder;
}

.fund {
  margin-left: 20px;
  margin-bottom: 10px;
}

.other-funds {
  margin-left: 20px;
}
</style>
